export const dateFromISO8601 = (date: string): Date => {
  const parts = date.match(/\d+/g);
  if (parts === null) {
    throw new Error(`could not parse date: ${date}`);
  }
  const [year, month, ...rest] = parts.map((part) => Number.parseInt(part));
  return new Date(Date.UTC(year, month - 1, ...rest));
};

/*
 * Prevents Invalid Date in Safari browser
 */
export const dateSafariCompatible = (date: string) =>
  new Date(date.replace(/-/g, '/'));
